import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import skinToggle from '../../../util/skinToggle.js'
import { resetStates } from './logout'
import RaisedButton from 'material-ui/RaisedButton'
import Util from '../../../util/util'
import _ from 'lodash'

let _log = Util.logger
let _cookie = Util.cookies
let _http = Util.http
const TOKEN = _cookie.keys.TOKEN
const EXPIRY = _cookie.keys.EXPIRY

class Header extends React.Component {

  logOut = () => {
    _cookie.write(TOKEN, '')
    _cookie.write(EXPIRY, '')
    this.props.resetStates()
    browserHistory.replace('/')
  }

  render = () => {
    let logoutButton = null
    if (_cookie.read('tn')) {
      if (_cookie.read('tn') !== '') {
        logoutButton = <RaisedButton
          className='raised-button'
          label='Log out'
          onClick={this.logOut} />
      }
    }

    let skinQueryParam = window.location.href.toLowerCase().match(/skin=([^&]*)/i)
    let skin = skinToggle.getSkin(skinQueryParam && skinQueryParam[1])    


      if (skin === 'walmart') {
      return this.includeWalmartHeader(logoutButton)
    } else if (skin === 'sams') {
      return this.includeSamsHeader(logoutButton)
    } else if (skin === 'walmartonline') {
      return this.includeWalmartOnlineHeader(logoutButton)    
    } else {
        // default skin is samsclub
      return this.includeSamsHeader(logoutButton)
    }    

  }

 includeSamsHeader (signoffButton) {
  return (
    <header>
      <div className='header-leftpadding'>&nbsp;</div>
      <a className='logo' target='_blank' href='https://www.samsclub.com' />
      <div className='header-logout'>{signoffButton}</div>
    </header>)
}


 includeWalmartOnlineHeader (signoffButton) {
  let headerReserveStyle = {
    paddingLeft: '20px'
  }

  let headerReturnStyle = {
    color: '#FFFFFF'
  }   

  return (
    <header>
    <div className="header-reserve">
      <div style={headerReserveStyle} className="header-secure">
        <div><a className='logo' target='_blank' href='https://www.walmart.com' /></div>
      </div>
    </div>
    <div></div>
    <div className='header-logout headerReturnStyle'>{signoffButton}</div>
    </header>)
}

 includeWalmartHeader (signoffButton) {
  return (
    <header>
      <div className='header-leftpadding'>&nbsp;</div>
      <a className='logo' target='_blank' href='https://www.walmart.com' />
      <div className='header-logout'>{signoffButton}</div>
    </header>)
}
}
Header.propTypes = {
  resetStates : PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  customer : state.customerOrderDetails
})

const mapDispatchToProps = {
  resetStates : () => resetStates()
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/layouts/skin/header/header.js